import { PayrollReport } from '@reporting/interfaces/report.interface';
import { format } from 'date-fns';
import { getInitialDatesForYTD } from './dates';

export class YTD implements PayrollReport {
    name = 'reporting.payroll.ytd.name';
    description = 'reporting.payroll.ytd.description';
    routerLink = 'ytd';
    apiEndpoint = 'payroll/ytd';
    allowsInclusionOfPendingPayrolls = true;
    hasExcel = true;
    hasPDF = false;
    hasCSV = false;
    showsPeriod = false;
    filterable = true;

    get fileName(): string {
        return `humi_ytd_report_${format(new Date(), 'YYYY_MM_DD')}.xlsx`;
    }

    getInitialDates = getInitialDatesForYTD;
}
